import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class CrucigramaApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/crucigrama/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/crucigrama/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getCrucigramaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigrama?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCrucigrama(id, token ) {  
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigrama/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(crucigrama, token ) {          
      let crucigramaEnvio = Object.assign({}, crucigrama);
		let comando="POST";
		if (crucigramaEnvio.id > 0) {
			comando="PUT";			
		} 
		crucigramaEnvio=JSON.stringify(crucigramaEnvio);
		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigrama/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: crucigramaEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getCrucigramaCombo(token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigrama/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}